import React, { useState, useEffect } from "react";
import { useGetSalesmen } from "hooks/order";
import { USER_PERMISSIONS } from "config/constants";

function useForm() {
  const [params, setParams] = useState({
    filters: {
      query: undefined,
      // permission: USER_PERMISSIONS.ACCOUNTANT_BANK,
    },
    pagination: {
      offset: 0,
      limit: 10,
    },
  });

  const { loading, hasMoreData, loadMoreSalesmen, data: options } = useGetSalesmen(params);

  const onSearch = (value) => {
    setParams({
      filters: { ...params.filters, query: value || undefined },
      pagination: { offset: 0, limit: 10 },
    });
  };

  return { loading, hasMoreData, loadMoreDataAccountantName: loadMoreSalesmen, options, onSearch };
}

export default useForm;
